// @ts-ignore
// @ts-nocheck
import { getAccessToken } from './accessTokenServices';
import apiIndecx from './apiIndecx';

type InvitesData = {
  actionId: string;
  active: boolean;
  answered: boolean;
  createdAt: string;
  email: string;
  indicators: string[];
  name: string;
  phone: string;
  shortUrl: string;
  status: string;
  updatedAt: string;
  validEmail: boolean;
  validPhone: boolean;
};

type GetUsersNotVotationResponse = {
  invites: InvitesData[];
  limit: number;
  page: number;
  total: number;
};

type CustomersData = {
  actionId: string;
  created_at: string;
  email: string;
  inviteId: string;
  nome: string;
  shortUrl: string;
  status: string;
  telefone: string;
};

type PostInviteVotationResponse = {
  customers: CustomersData[];
};

export const getUsersNotVotation = async (
  email: string
): Promise<GetUsersNotVotationResponse> => {
  const access_token = await getAccessToken();

  const response = await apiIndecx.get(
    `/invites/${process.env.REACT_APP_NEW_NPS_ACTION}?email=${email}`,
    {
      headers: {
        access_token,
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
    }
  );

  return response.data;
};

export const postInviteVotation = async (
  nome: string,
  email: string,
  telefone: string
): Promise<PostInviteVotationResponse> => {
  const access_token = await getAccessToken();

  const body = {
    customers: [
      {
        nome,
        email,
        telefone,
      },
    ],
  };

  const response = await apiIndecx.post(
    `/invites/${process.env.REACT_APP_NEW_NPS_ACTION}`,
    body,
    {
      headers: {
        access_token,
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
    }
  );
  return response.data;
};
